import './compliance.css';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import Licences from './tabs/Licences';

export const RefDataContext = React.createContext();

const RefData = () => {
  const [onAddNew, setOnAddNew] = useState(() => () => {});
  const [activeTab, setActiveTab] = useState('licences');
  const addHandlers = useRef({});

  const registerAddHandler = useCallback(
    (tabKey, handler) => {
      addHandlers.current[tabKey] = handler;
      if (tabKey === activeTab) {
        setOnAddNew(() => (typeof handler === 'function' ? handler : () => {}));
      }
    },
    [activeTab]
  );

  const refDataState = {
    registerAddHandler,
    // legacy alias
    setOnAddNew: (handler) => registerAddHandler(activeTab, handler),
  };

  useEffect(() => {
    const handler = addHandlers.current[activeTab];
    setOnAddNew(() => (typeof handler === 'function' ? handler : () => {}));
  }, [activeTab]);

  return (
    <RefDataContext.Provider value={refDataState}>
      <Container fluid="2xl" className=" mt-5 semi-fluid-container medium-middle-container ">
        <section className="floating-box-userProfile pb-2 px-4">
          <div className="floating-box-header-userProfile ps-0 ms-0">
            <span>Compliance</span>
            <span className="flex-grow-1"></span>
            <button
              className="stepper-button"
              style={{ fontFamily: 'Roboto', minWidth: 110, maxWidth: 110 }}
              onClick={() => {
                if (typeof onAddNew === 'function') onAddNew();
              }}
            >
              New
            </button>
          </div>

          <Tabs
            defaultActiveKey={'licences'}
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            mountOnEnter={true}
            unmountOnExit={true}
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="licences" title="Licences">
              <Licences />
            </Tab>
          </Tabs>
        </section>
      </Container>
    </RefDataContext.Provider>
  );
};

export default RefData;
